'use client';

import { useRef } from 'react';

const ScrollToSection = ({ sectionId, children }) => {
  const sectionRef = useRef(null);

  const scrollToSection = () => {
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      const offsetTop = targetElement.offsetTop - 200;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  };
  return (
    <div ref={sectionRef} onClick={scrollToSection} className="cursor-pointer">
      {children}
    </div>
  );
};

export default ScrollToSection;
